import React, { useContext, useEffect, useState } from "react";
import { Header } from "./Header";
import { Link } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { AuthContext, base_url } from "../context/Authcontext";
import ToastMessage from "./ToastMessage";
import axios from "axios";
import MarqueeBottom from "./components/MarqueeBottom";
import { formatINR } from "../utils/money";
import { UsdtDeposit } from "./components/Usdt";

export const Deposit = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [isManualDepo, setManualDeposit] = useState(true);
  const [isUpiDeposit, setUpiDeposit] = useState(false);
  const [isBankPay, setBankPay] = useState(false);
  const [isUsdt, setUsdt] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("Paytm"); 
  const { getBankDetails } = useContext(AuthContext);
  const [bankDetails, setBankDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [depositHistory, setDepositHistory] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedUpi, setSelectedUpi] = useState('');
  const [selectedBank, setSelectedBank] = useState(null);
  let [selectedDepositData , setselectedDepositData] = useState(null);
  const [selectedQr, setSelectedQr] = useState(null);
    const [recharges, setRecharges] = useState([]);
    const [rechargeTimers, setRechargeTimers] = useState({});

 
  const [error, setError] = useState(null)
  
  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);


  // console.log("is banke ", isBankPay);
  // console.log("isManualDepo ", isManualDepo);
  // console.log("isUpiDeposit ", isUpiDeposit);
  // console.log("isUsdt ", isUsdt);


  // console.log("selected bandk js ", selectedBank);
  // console.log("selected up1", selectedUpi);

  let selectebank ="";

  if (isBankPay) {
     selectebank = selectedBank?.account_number;
    } else if (isManualDepo) {
     selectebank = selectedUpi
    } else if (isUpiDeposit) {
     selectebank = "qrcode"
    } else {
      selectebank = "usdt"
    }

  // console.log("slelctd dbhhsjnd", selectebank);
 
  
  // for upi manual transaction
  const [upiTrans, setUpiTrans] = useState({ utr: "", amount: "",paymentProof: null });
  // RB-088: guard against double-submit on slow networks
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Function to determine which UPI to use based on amount
const getSelectedUpi = () => {
  if (!bankDetails) return '';

  console.log("bank details in upi", bankDetails);

  if (bankDetails?.upi1 === 1) {
    return bankDetails?.upi_id || '';
  } else if (bankDetails?.upi2 === 1) {
    return bankDetails?.upi_id2 || '';
  } else if (bankDetails?.upi3 === 1) {
    return bankDetails?.upi_id3 || '';
  } else if (bankDetails?.upi4 === 1) {
    return bankDetails?.upi_id4 || '';
  }
  return null;
};

const getSelectedBank = () => {
  if (!bankDetails) return null;

  if (bankDetails.bank1 === 1) {
    return {
      account_number: bankDetails.account_number || '',
      holder_name: bankDetails.holder_name || '',
      bank_name: bankDetails.bank_name || '',
      ifsc_code: bankDetails.ifsc_code || ''
    };
  } else if (bankDetails.bank2 === 1) {
    return {
      account_number: bankDetails.account_number2 || '',
      holder_name: bankDetails.holder_name2 || '',
      bank_name: bankDetails.bank_name2 || '',
      ifsc_code: bankDetails.ifsc_code2 || ''
    };
  } else if (bankDetails.bank3 === 1) {
    return {
      account_number: bankDetails.account_number3 || '',
      holder_name: bankDetails.holder_name3 || '',
      bank_name: bankDetails.bank_name3 || '',
      ifsc_code: bankDetails.ifsc_code3 || ''
    };
  } else if (bankDetails.bank4 === 1) {
    return {
      account_number: bankDetails.account_number4 || '',
      holder_name: bankDetails.holder_name4 || '',
      bank_name: bankDetails.bank_name4 || '',
      ifsc_code: bankDetails.ifsc_code4 || ''
    };
  }
  return null;
};

const getSelectQr = () => {
  if (!bankDetails) return null;

  if (bankDetails.qr1 === 1) {
    return { qr_image: bankDetails.qr_code_image || '' };
  } else if (bankDetails.qr2 === 1) {
    return { qr_image: bankDetails.qr_code_image2 || '' };
  } else if (bankDetails.qr3 === 1) {
    return { qr_image: bankDetails.qr_code_image3 || '' };
  } else if (bankDetails.qr4 === 1) {
    return { qr_image: bankDetails.qr_code_image4 || '' };
  }
  return null;
};
// helper to parse "2025-09-06 03:36:55 PM" → valid Date
// helper to parse "2025-09-06 03:36:55 PM"
const parseDate = (dateStr) => {
  const [datePart, timePart, modifier] = dateStr.split(" ");
  let [hours, minutes, seconds] = timePart.split(":").map(Number);

  if (modifier === "PM" && hours < 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return new Date(
    `${datePart}T${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`
  );
};

const fetchRecharges = async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${base_url}/api/webapi/depositeTimer`, {
      withCredentials: true,
    });

    if (response.data.success && response.data.data) {
      const recharge = response.data.data;
      setRecharges([recharge]);
      setRechargeTimers({ [recharge.id]: recharge.timeRemaining });
    } else {
      setError("No recharge history found");
      setRecharges([]);
    }
  } catch (err) {
    console.error(err);
    setError("Server error");
  } finally {
    setLoading(false);
  }
};






  useEffect(() => {
    fetchRecharges();
  }, []);


  useEffect(() => {
    setUpiTrans({ utr: "", amount: "", paymentProof: null });
  }, [paymentMethod]);

  const setPaymentTab = (method) => {
    // Reset all tab states
    setManualDeposit(false);
    setUpiDeposit(false);
    setBankPay(false);
    setUsdt(false);
    
    // Set the selected tab and update payment method
    switch(method) {
      case "UPI":
        setManualDeposit(true);
        setPaymentMethod("UPI");
        break;
      case "Paytm":
        setUpiDeposit(true);
        setPaymentMethod("Paytm");
        break;
      case "Bank":
        setBankPay(true);
        setPaymentMethod("Bank");
        break;
      case "USDT":
        setUsdt(true);
        setPaymentMethod("USDT");
        break;
      default:
        setManualDeposit(true);
        setPaymentMethod("UPI");
    }
  };
  
// Fix the handleChange function - this looks correct already
const handleChange = (e) => {
  const { name, value } = e.target;
  setUpiTrans((prevData) => ({
    ...prevData,
    [name]: value,
  }));
  

 

  // If amount field is changed, update the selected UPI
  // if (name === 'amount') {
  //   setSelectedUpi(getSelectedUpi(value));
  //   setSelectedBank(getSelectedBank(value));
  //   setSelectedQr(getSelectQr(value));
  // }
};


  const handleAmount = (amount) => {
    setUpiTrans((prev) => ({
      ...prev,
      amount: amount,
    }));

    setSelectedUpi(getSelectedUpi(amount));
    setSelectedBank(getSelectedBank(amount));
    setSelectedQr(getSelectQr(amount));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type || !file.type.startsWith("image/")) {
      ToastMessage(0, "Unsupported file format. Please upload a valid image file.");
      e.target.value = "";
      setUpiTrans(prev => ({ ...prev, paymentProof: null }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      ToastMessage(0, "Image must be 5MB or smaller.");
      e.target.value = "";
      setUpiTrans(prev => ({ ...prev, paymentProof: null }));
      return;
    }
    setUpiTrans(prev => ({
      ...prev,
      paymentProof: file
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formEl = e.target;
    if (isSubmitting) return; // dedupe double-clicks (RB-088)
    if(upiTrans.utr===""){
      ToastMessage(0,"Utr is required");
      return;
    }
    if(upiTrans.amount===""){
      ToastMessage(0,"Amount must be required");
      return;
    }

    if(!upiTrans.paymentProof) {
      ToastMessage(0, "Payment proof image is required");
      return;
    }

    setIsSubmitting(true);

    const data = { utr: upiTrans.utr, money: upiTrans.amount,paymentMethod: paymentMethod };
    const formData = new FormData();
    formData.append("utr", upiTrans.utr);
    formData.append("money", upiTrans.amount);
    formData.append("paymentMethod", paymentMethod);
    formData.append("paymentProof", upiTrans.paymentProof);
    formData.append("bankOrUpiData" , selectebank)

    console.log("FormData content:");
    for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]); // Debugging FormData
    }

    try {
      const response = await axios.post(
        `${base_url}/api/webapi/deposite`,
        formData,
        {
          withCredentials: true,
          timeout: 30000, // 30s timeout — prevents indefinite spinner on hung uploads
          headers: {
            Accept: "application/json",
             "Content-Type": "multipart/form-data"
          },
        }
      );
   if (response.data.status) {
  ToastMessage(1, response.data.message);

  const newRecharge = {
    id: Date.now(),
    money: upiTrans.amount,
    type: paymentMethod,
    status: 0,
    today: new Date().toLocaleString("en-US", { hour12: true }),
  };

  setRecharges([newRecharge]);
  setRechargeTimers({ [newRecharge.id]: 180 }); // immediate 3 min timer

  setUpiTrans({ utr: "", amount: "", paymentProof: null });
  if (formEl && typeof formEl.reset === "function") formEl.reset();
  setRefresh((prev) => !prev);
} else {
  ToastMessage(0, response.data.message);
}


    } catch (err) {
      ToastMessage(0, err?.code === "ECONNABORTED" ? "Request timed out — please try again" : "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownload = () => {
    try {
      const qrCode = document.querySelector(".qrcodeImage");
      const qrCodeUrl = qrCode.src;
      fetch(qrCodeUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch the QR Code.");
          }
          return response.blob();
        })
        .then((blob) => {
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);

          link.href = url;
          link.download = "qrCode.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading the QR Code:", error.message);
          alert(
            "An error occurred while downloading the QR Code. Please try again."
          );
        });
    } catch (error) {
      alert("An unexpected error occurred. Please try again.");
    }
  };
  const handleUpiCopy = (id) => {
    if (id) {
      navigator.clipboard.writeText(id);
      ToastMessage(1, "Copied Successfully!");
    }
  };

  useEffect(() => {

   
    const fetchDetails = async () => {
      const data = await getBankDetails();
      console.log("bank details", data);
      if (data) {
        setBankDetails(data);
      }
      setLoading(false);
    };
    const fetchDepositHistory = async () => {
      try {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/historyListDeposit`,
          {},
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        if (res.data && Array.isArray(res.data.depositList)) {
          setDepositHistory(res.data.depositList);
        }
      } catch (err) {
        console.log(err);
      }
    };
    
    fetchDepositHistory();
    fetchDetails();
  }, [refresh]);

  useEffect(() => {
  if (bankDetails) {
    // alert()
    setSelectedUpi(getSelectedUpi());
    setSelectedBank(getSelectedBank());
    setSelectedQr(getSelectQr());
  }
}, [bankDetails]);

 const [timeLeft, setTimeLeft] = useState(60); // countdown from 60 seconds

  useEffect(() => {
    if (timeLeft <= 0) return; // stop timer at 0
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // cleanup
  }, [timeLeft]);

  // optional: format time as MM:SS
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };


  useEffect(() => {
  const interval = setInterval(() => {
    setRechargeTimers(prev => {
      const newTimers = { ...prev };
      let hasPending = false;

      for (let id in newTimers) {
        if (newTimers[id] > 0) {
          newTimers[id] -= 1;
          hasPending = true;
        }
      }

      if (!hasPending) clearInterval(interval);

      return newTimers;
    });
  }, 1000);

  return () => clearInterval(interval);
}, [rechargeTimers]);


  


  useEffect(() => {
    if (upiTrans.amount) {


      console.log("amount changed", upiTrans.amount);
      setSelectedUpi(getSelectedUpi(upiTrans.amount));
    }
  }, [upiTrans.amount, bankDetails]);

  useEffect(() => {
    if (upiTrans.amount) {
      setSelectedBank(getSelectedBank(upiTrans.amount));
    }


  }, [upiTrans.amount, bankDetails]);
  useEffect(() => {
    if (upiTrans.amount) {
      setSelectedQr(getSelectQr(upiTrans.amount));
    }
  }, [upiTrans.amount, bankDetails]);
  return (
    <>
      <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
      <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />
      <app-root _nghost-shi-c101="" ng-version="12.2.16">
        <div _ngcontent-shi-c101="">
          <app-toasts
            _ngcontent-shi-c101=""
            aria-live="polite"
            aria-atomic="true"
            className="ngb-toasts"
          ></app-toasts>

          <app-exchange _nghost-shi-c80="" className="ng-star-inserted">
            <div _ngcontent-shi-c80="" className="wrapper">
              <div _ngcontent-shi-c80="" id="content100">
                <div _ngcontent-shi-c80="" className="">
                  <div _ngcontent-shi-c80="" className="">
                    <div _ngcontent-shi-c80="" className="col-sm-12">
                      {/* <app-news-ticker _ngcontent-shi-c80="" _nghost-shi-c70="">
                        <div
                          _ngcontent-shi-c70=""
                          className="alet bg-light alert-darkmode"
                        >
                          <div className="marquee">
                            <marquee>
                              👉👉🏏WOMEN BIG BASH 2024 PREMIUM MATCH AND FANCY
                              MARKETS ARE AVAILABLE. PLAY NOW AND WIN BIG WITH
                              KHELOYAR.🏏.💰GET CASH BONUS ON EVERY DEPOSIT
                              💸..👈👈
                            </marquee>
                          </div>
                        </div>
                      </app-news-ticker> */}
                    </div>
                  </div>

                  <app-deposit _nghost-shi-c153="" className="ng-star-inserted">
                    <div _ngcontent-shi-c153="" className="dep-sec">
                      <auto-deposit
                        _nghost-shi-c158=""
                        className="ng-star-inserted"
                      >
                       
                        <div _ngcontent-shi-c158="" className="payment-method ">

              

                          <ul
                            _ngcontent-shi-c158=""
                            style={{ listStyle: "none" }}
                          >
                            {/* <li
                              _ngcontent-shi-c158=""
                              className="ng-star-inserted activeOption"
                            >
                              <Link
                                _ngcontent-shi-c158=""
                                className="img_box_wrapper"
                                onClick={() => {
                                  setManualDeposit(true);
                                  setUpiDeposit(false);
                                  setBankPay(false);
                                  setUsdt(false);
                                  setPaymentTab("UPI")
                                }}
                              >
                                <span
                                  _ngcontent-shi-c158=""
                                  className={`${
                                    isManualDepo ? "" : "d-none"
                                  } selected ng-star-inserted`}
                                >
                                  <svg
                                    _ngcontent-shi-c158=""
                                    className="svg-inline--fa fa-check-circle fa-w-16"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="check-circle"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    data-fa-i2svg=""
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                                    ></path>
                                  </svg>
                                </span>
                                <img
                                  alt="Upi"
                                  _ngcontent-shi-c158=""
                                  src="/assets/images/Upi.png"
                                />
                              </Link>
                            </li> */}

                            <li
                              _ngcontent-shi-c158=""
                              className="ng-star-inserted activeOption"
                            >
                              <Link
                                _ngcontent-shi-c158=""
                                className="img_box_wrapper"
                                onClick={() => {
                                  setUpiDeposit(true);
                                  setManualDeposit(false);
                                  setBankPay(false);
                                  setUsdt(false);
                                  setPaymentTab("Paytm")
                                }}
                              >
                                <span
                                  _ngcontent-shi-c158=""
                                  className={`${
                                    isUpiDeposit ? "" : "d-none"
                                  } selected ng-star-inserted`}
                                >
                                  <svg
                                    _ngcontent-shi-c158=""
                                    className="svg-inline--fa fa-check-circle fa-w-16"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="check-circle"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    data-fa-i2svg=""
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                                    ></path>
                                  </svg>
                                </span>
                                <img
                                  _ngcontent-shi-c158=""
                                  alt="PhonePe"
                                  src="/assets/images/PhonePe.png"
                                />
                              </Link>
                            </li>
                            <li
                              _ngcontent-shi-c158=""
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-shi-c158=""
                                className="img_box_wrapper"
                                onClick={() => {
                                  setBankPay(true);
                                  setManualDeposit(false);
                                  setUpiDeposit(false);
                                  setUsdt(false);
                                  setPaymentTab("Bank")
                                }}
                              >
                                <span
                                  _ngcontent-shi-c158=""
                                  className={`${
                                    isBankPay ? "" : "d-none"
                                  } selected ng-star-inserted`}
                                >
                                  <svg
                                    _ngcontent-shi-c158=""
                                    className="svg-inline--fa fa-check-circle fa-w-16"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="check-circle"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    data-fa-i2svg=""
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                                    ></path>
                                  </svg>
                                </span>
                                <img
                                  _ngcontent-shi-c158=""
                                  alt="Bank"
                                  src="/assets/images/Bank.png"
                                />
                              </Link>
                            </li>
                            <li
                              _ngcontent-shi-c158=""
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-shi-c158=""
                                className="img_box_wrapper"
                                onClick={() => {
                                  setUsdt(true);
                                  setBankPay(false);
                                  setManualDeposit(false);
                                  setUpiDeposit(false);
                                  setPaymentTab("USDT")
                                }}
                              >
                                <span
                                  _ngcontent-shi-c158=""
                                  className={`${
                                    isUsdt ? "" : "d-none"
                                  } selected ng-star-inserted`}
                                >
                                  <svg
                                    _ngcontent-shi-c158=""
                                    className="svg-inline--fa fa-check-circle fa-w-16"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="check-circle"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    data-fa-i2svg=""
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                                    ></path>
                                  </svg>
                                </span>
                                <img
                                  _ngcontent-shi-c158=""
                                  alt="USDT"
                                  src="/assets/images/USDT.svg"
                                />
                              </Link>
                            </li>
                          </ul>



                            
                        </div>
    <div className="recharge-list">
  {recharges.map((r) => (
    <div
      key={r.id}
      className="recharge-item shadow-sm p-2  rounded"
      style={{
        backgroundColor: "#f9f9f9",
        borderLeft: r.status === 0 
          ? "5px solid orange" 
          : r.status === 1 
          ? "5px solid green" 
          : "5px solid red",
      }}
    >
      {/* Header */}
      {/* <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0 text-primary">Recharge ID: {r.id_order}</h6>
        <small className="text-muted">{new Date(r.today).toLocaleString()}</small>
      </div> */}

      {/* Body */}
      <div className="d-flex justify-content-between">
        <p className="mb-1 text-black">
          <strong>Amount:</strong> ₹{r.money}
        </p>
        <p className="mb-1">
          <strong>Type:</strong> {r.type}
        </p>
      </div>

      {/* Status Section */}
      <div>
        {r.status === 0 && rechargeTimers[r.id] > 0 && (
          <p className="mb-0 fw-bold text-warning">
            ⏳ Pending... Timer: {formatTime(rechargeTimers[r.id])}
          </p>
        )}

        {r.status === 0 && rechargeTimers[r.id] === 0 && (
          <p className="mb-0 fw-bold text-danger">⚠️ Last Recharge Pending</p>
        )}

        {r.status === 1 && (
          <p className="mb-0 fw-bold text-success">✅ Last Recharge Accepted</p>
        )}

        {r.status === 2 && (
          <p className="mb-0 fw-bold text-danger">❌ Last Recharge  Rejected</p>
        )}
      </div>
    </div>
  ))}
</div>



                        {/* manual_deposit_method */}
{(isManualDepo || isUpiDeposit) && (
  <app-manual-deposit
    _ngcontent-shi-c158=""
    _nghost-shi-c157=""
    className="ng-star-inserted"
  >
    <div
      _ngcontent-shi-c157=""
      className="tab-content ng-star-inserted "
      style={{background:"#7dc4ff"}}
    >
      <div
        _ngcontent-shi-c157=""
        noValidate=""
        className="ng-untouched ng-pristine ng-invalid"
      >
        <div
          _ngcontent-shi-c157=""
          className="st_blog_detail"
        >
          <div
            _ngcontent-shi-c157=""
            className="st_blog_detail_thumb"
          >
            <div
              _ngcontent-shi-c157=""
              className="st_featured_thumb"
            >
              <div
                _ngcontent-shi-c157=""
                className="heading"
              >
                PAYMENT DETAILS{" "}
              </div>
              <div
                _ngcontent-shi-c157=""
                className="text_wrper"
              >
                <div
                  _ngcontent-shi-c157=""
                  className="bb_transfer_subsection"
                   style={{marginBottom:"39px"}}
                >
                  {/* The whole row goes when neither method is configured;
                      otherwise its spacers alone left a stray empty strip
                      above the payment-slip form. */}
                  {loading || selectedUpi || selectedQr?.qr_image ? (
                  <div
                    _ngcontent-shi-c157=""
                    className="payment-list"
                  >
                    {/* Hidden when no UPI id is configured -- the panel used to
                        render regardless and just read "UPI not available",
                        leaving a half-empty row next to the QR. */}
                    {loading || selectedUpi ? (
                    <div
                      _ngcontent-shi-c157=""
                      className="payment"
                    >
                      <img
                        _ngcontent-shi-c157=""
                        alt=""
                        height="20"
                        src="/assets/images/Upi.png"
                        className="d-block m-auto mt-2"
                      />

                      <div _ngcontent-qhb-c158="" className="sectionList">
                        <div _ngcontent-qhb-c158="" className="bb_tran_subdiv">
<div className="bb_bank_name" style={{fontSize:"14px"}}>
  UPI Id:{" "}
  {loading
    ? "loading.."
    : selectedUpi 
      ? selectedUpi 
      : "UPI not available"}
</div>

                        </div>
                        <div
                          _ngcontent-qhb-c158=""
                          copy_value="044484100000302"
                          className="bb_copy_txt"
                        >
                          <div
                            _ngcontent-qhb-c158=""
                            className="bb_tran_subdiv_sec"
                          ></div>
                          <img
                            _ngcontent-qhb-c158=""
                            className="click_btn"
                            style={{
                              position: "relative",
                            }}
                            src="/assets/images/copy.svg"
                            alt=""
                            onClick={() =>
                              handleUpiCopy(
                                upiTrans.amount && selectedUpi 
                                  ? selectedUpi 
                                  : bankDetails?.upi_id
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    ) : null}{" "}
                    &nbsp; &nbsp;{" "}
                       {/* Only render the QR when one is actually configured.
                           It used to render unconditionally, so with no QR set
                           the src became "/payment/undefined" and the box --
                           which is deliberately white so a real QR can be
                           scanned -- showed as an empty white square on the
                           dark page. The same applies in reverse to the UPI
                           panel above, so with only one method configured the
                           remaining one now centres instead of sitting beside
                           a blank. */}
                       {selectedQr?.qr_image ? (
                       <div _ngcontent-oxq-c160="" className="qr">
                      <div
                        _ngcontent-oxq-c160=""
                        className="bb_tran_subdiv"
                      >
                        <img
                          _ngcontent-oxq-c160=""
                          className="qrcodeImage"
                          alt="Scan this QR code to pay"
                          src={`${base_url}/payment/${selectedQr.qr_image}`}
                        />
                      </div>
                    </div>
                       ) : null}
                  </div>
                  ) : null}

                  {/* QR Code Section */}
                  {/* <div
                    _ngcontent-oxq-c160=""
                    className="pay-with-qr ng-star-inserted"
                  >
                  
                 
                  </div> */}

                  {/* QR Code Section */}
                  {/* <div
                    _ngcontent-oxq-c160=""
                    className="pay-with-qr ng-star-inserted"
                  >
                    <div _ngcontent-oxq-c160="" className="download">
                      <p _ngcontent-oxq-c160="">Pay with QR Code</p>
                      <button
                        _ngcontent-oxq-c160=""
                        appdownloadimage=""
                        className="download-btn"
                        onClick={handleDownload}
                      >
                        Download &amp; Pay
                      </button>
                    </div>
                    <div _ngcontent-oxq-c160="" className="qr">
                      <div
                        _ngcontent-oxq-c160=""
                        className="bb_tran_subdiv"
                      >
                        <img
                          _ngcontent-oxq-c160=""
                          className="qrcodeImage"
                          alt="No QR code available"
                          src={`https://asexch.online${selectedQr?.qr_image}`}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div
                    _ngcontent-shi-c157=""
                    className="form-group"
                    
                  >
                    <div
                      _ngcontent-shi-c157=""
                      className="heading"
                    >
                      SEND YOUR PAYMENT SLIP
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div _ngcontent-shi-c157="" className="withdraw_text">
                        <p _ngcontent-shi-c157="" className="bb_head">
                          Payment Proof Image
                        </p>
                        <div _ngcontent-shi-c157="" className="input_dec select_dec2 marg-dec">
                          <input
                            _ngcontent-shi-c157=""
                            type="file"
                            name="paymentProof"
                            accept="image/*"
                            className="ng-untouched ng-pristine ng-invalid"
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                      <br></br>
                      <div
                        _ngcontent-shi-c157=""
                        className="submit-sec withdraw_text unique-text"
                      >
                        <p
                          _ngcontent-shi-c157=""
                          className="bb_head"
                        >
                          {" "}
                          Unique Transaction Reference{" "}
                        </p>
                        <div
                          _ngcontent-shi-c157=""
                          className="input_dec select_dec2 marg-dec"
                        >
                          <input
                            _ngcontent-shi-c157=""
                            formcontrolname="utrTransactionId"
                            type="text"
                            autoComplete="off"
                            id="reference_id"
                            name="utr"
                            className="amount number_only ng-untouched ng-pristine ng-invalid text-white"
                            placeholder="6 to 12 Digits UTR Number"
                            maxLength="12"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div
                        _ngcontent-shi-c157=""
                        className="withdraw_text"
                      >
                        <br></br>
                        <p
                          _ngcontent-shi-c157=""
                          className="bb_head"
                        >
                          Amount
                        </p>
                        <div
                          _ngcontent-shi-c157=""
                          className="input_dec select_dec2 marg-dec"
                        >
                          <input
                            _ngcontent-shi-c157=""
                            formcontrolname="amount"
                            type="number"
                            name="amount"
                            placeholder="Amount"
                            autoComplete="off"
                            className="amount number_only ng-untouched ng-pristine ng-invalid text-white"
                            min="100"
                            maxLength="12"
                            value={upiTrans.amount}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div
                        _ngcontent-shi-c157=""
                        className="month_tab"
                      >
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="0"
                          onClick={() =>
                            handleAmount("100")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +100{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="0"
                          onClick={() =>
                            handleAmount("300")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +300{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="1"
                          onClick={() =>
                            handleAmount("1000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +1000{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="2"
                          onClick={() =>
                            handleAmount("2000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +2000{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="3"
                          onClick={() =>
                            handleAmount("5000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +5000{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="4"
                          onClick={() =>
                            handleAmount("10000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +10000{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="5"
                          onClick={() =>
                            handleAmount("20000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +20000{" "}
                        </div>
                        <div
                          _ngcontent-shi-c157=""
                          className="quick_amt offline_amount label2 ng-star-inserted"
                          tabIndex="6"
                          onClick={() =>
                            handleAmount("25000")
                          }
                        >
                          <i _ngcontent-shi-c157=""></i>
                          +25000{" "}
                        </div>
                      </div>

                      <button
                        _ngcontent-shi-c157=""
                        className="bank-submit-btn cursor-pointer"
                        type="submit"
                        disabled={isSubmitting}
                        aria-busy={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "submit"}
                      </button>
                    </form>
                  </div>

                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-manual-deposit>
)}
                        {/* Bank_deposit */}
                        {isBankPay && (
                          <app-manual-deposit
                            _ngcontent-shi-c158=""
                            _nghost-shi-c157=""
                            className="ng-star-inserted"
                          >
                            <div
                              _ngcontent-shi-c157=""
                              className="tab-content ng-star-inserted "
                                   style={{background:"#7dc4ff"}}
                            >
                              <form
                                onSubmit={handleSubmit}
                                _ngcontent-shi-c157=""
                                noValidate=""
                                className="ng-untouched ng-pristine ng-invalid"
                                style={{ width: "100%" }}
                              >
                                <div
                                  _ngcontent-shi-c157=""
                                  className="st_blog_detail"
                                >
                                  <div
                                    _ngcontent-shi-c157=""
                                    className="st_blog_detail_thumb"
                                  >
                                    <div
                                      _ngcontent-shi-c157=""
                                      className="st_featured_thumb"
                                    >
                                      <div
                                        _ngcontent-shi-c157=""
                                        className="heading"
                                      >
                                        PAYMENT DETAILS{" "}
                                      </div>
                                      <div
                                        _ngcontent-shi-c157=""
                                        className="text_wrper"
                                      >
                                        <div
                                          _ngcontent-shi-c157=""
                                          className="bb_transfer_subsection"
                                          style={{marginBottom:"39px"}}
                                        >
                                          <div>
                                            <div
                                              _ngcontent-shi-c157=""
                                              className="payment-list"
                                            >
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="payment"
                                              >
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="text-nowrap"
                                                >
                                                  Bank / IMPS Transfer
                                                </span>
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="animated-btn"
                                                >
                                                  <span _ngcontent-shi-c157="">
                                                    Click Here
                                                  </span>
                                                </span>
                                                <img
                                                  _ngcontent-shi-c157=""
                                                  alt=""
                                                  height="20"
                                                  src="/assets/images/account.svg"
                                                  className="d-block m-auto mt-2"
                                                />
                                              </div>{" "}
                                              &nbsp; &nbsp;{" "}
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="payment"
                                              >
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="text-nowrap"
                                                >
                                                  UPI / PhonePe / G Pay{" "}
                                                </span>
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="animated-btn"
                                                >
                                                  <span _ngcontent-shi-c157="">
                                                    Click Here
                                                  </span>
                                                </span>
                                                <img
                                                  _ngcontent-shi-c157=""
                                                  alt=""
                                                  height="20"
                                                  src="/assets/images/multi-payment.svg"
                                                  className="d-block m-auto mt-2"
                                                />
                                              </div>
                                            </div>
                                            <div
                                              _ngcontent-shi-c157=""
                                              className="form-group"
                                            >
                                              <div
                                                _ngcontent-qhb-c158=""
                                                className="st_blog_detail_thumb"
                                              >
                                                <div
                                                  _ngcontent-qhb-c158=""
                                                  className="st_featured_thumb"
                                                >
                                                  <div
                                                    _ngcontent-qhb-c158=""
                                                    className="text_wrper"
                                                  >
                                                    <div
                                                      _ngcontent-qhb-c158=""
                                                      className="bb_transfer_div"
                                                    >
                                                      <div
                                                        _ngcontent-qhb-c158=""
                                                        className="bb_transfer_subsection"
                                                        style={{
                                                          marginTop:
                                                            "0px !important",
                                                        }}
                                                      >
                                                        <div
                                                          _ngcontent-qhb-c158=""
                                                          className="sectionList"
                                                        >
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            className="bb_tran_subdiv"
                                                          >
                                                            <div _ngcontent-qhb-c158="" className="bb_bank_name">
  Account Number: {loading ? (
    <div>loading..</div>
  ) : (
    selectedBank?.account_number || 'No Account Number'
  )}
</div>
                                                          </div>
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            copy_value="044484100000302"
                                                            className="bb_copy_txt"
                                                          >
                                                            <div
                                                              _ngcontent-qhb-c158=""
                                                              className="bb_tran_subdiv_sec"
                                                            ></div>
                                                            <img
                                                              _ngcontent-qhb-c158=""
                                                              className="click_btn"
                                                              src="/assets/images/copy.svg"
                                                              alt=""
                                                              onClick={() =>
                                                                handleUpiCopy(
                                                                  bankDetails?.account_number
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-qhb-c158=""
                                                          className="sectionList"
                                                        >
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            className="bb_tran_subdiv"
                                                          >
                                                           <div _ngcontent-qhb-c158="" className="bb_bank_name">
  Holder Name: {loading ? (
    <div>loading..</div>
  ) : (
    selectedBank?.holder_name || 'No Holder Name'
  )}
</div>
                                                          </div>
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            copy_value="WASHETTE SERVICES OPC PVT LTD"
                                                            className="bb_copy_txt"
                                                          >
                                                            <div
                                                              _ngcontent-qhb-c158=""
                                                              className="bb_tran_subdiv_sec"
                                                            ></div>
                                                            <img
                                                              _ngcontent-qhb-c158=""
                                                              className="click_btn"
                                                              src="/assets/images/copy.svg"
                                                              alt=""
                                                              onClick={() =>
                                                                handleUpiCopy(
                                                                  bankDetails?.holder_name
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-qhb-c158=""
                                                          className="sectionList"
                                                        >
                                                         <div _ngcontent-qhb-c158="" className="bb_bank_name">
  Bank Name: {loading ? (
    <div>loading..</div>
  ) : (
    selectedBank?.bank_name || 'No Bank Name'
  )}
</div>
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            copy_value="YES BANK"
                                                            className="bb_copy_txt"
                                                          >
                                                            <div
                                                              _ngcontent-qhb-c158=""
                                                              className="bb_tran_subdiv_sec"
                                                            ></div>
                                                            <img
                                                              _ngcontent-qhb-c158=""
                                                              className="click_btn"
                                                              src="/assets/images/copy.svg"
                                                              alt=""
                                                              onClick={() =>
                                                                handleUpiCopy(
                                                                  bankDetails?.bank_name
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </div>

                                                        <div
                                                          _ngcontent-qhb-c158=""
                                                          className="sectionList"
                                                        >
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            className="bb_tran_subdiv"
                                                          >
                                                          <div _ngcontent-qhb-c158="" className="bb_bank_name">
  IFSC Code: {loading ? (
    <div>loading..</div>
  ) : (
    selectedBank?.ifsc_code || 'No IFSC Code'
  )}
</div>
                                                          </div>
                                                          <div
                                                            _ngcontent-qhb-c158=""
                                                            copy_value="YESB0000444"
                                                            className="bb_copy_txt"
                                                          >
                                                            <div
                                                              _ngcontent-qhb-c158=""
                                                              className="bb_tran_subdiv_sec"
                                                            ></div>
                                                            <img
                                                              _ngcontent-qhb-c158=""
                                                              className="click_btn"
                                                              src="/assets/images/copy.svg"
                                                              alt=""
                                                              onClick={() =>
                                                                handleUpiCopy(
                                                                  bankDetails?.ifsc_code
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="heading"
                                              >
                                                SEND YOUR PAYMENT SLIP
                                              </div>
                                              <div
                                                _ngcontent-qhb-c158=""
                                                className="st_featured_thumb"
                                              >
                                                <div
                                                  _ngcontent-qhb-c158=""
                                                  className="text_wrper"
                                                >

                                                  
                                                  <div
                                                    _ngcontent-qhb-c158=""
                                                    className="bb_transfer_subsection"
                                                     style={{marginBottom:"39px"}}
                                                  >
                                                    
                                          <div _ngcontent-shi-c157="" className="withdraw_text">
      <p _ngcontent-shi-c157="" className="bb_head">
        Payment Proof Image
      </p>
      <div _ngcontent-shi-c157="" className="input_dec select_dec2 marg-dec">
        <input
          _ngcontent-shi-c157=""
          type="file"
          name="paymentProof"
          accept="image/*"
          className="ng-untouched ng-pristine ng-invalid"
          onChange={handleFileChange}
        />
      </div>
    </div>
                                                    <div
                                                      _ngcontent-qhb-c158=""
                                                      className="withdraw_text"
                                                    >
                                                      <p
                                                        _ngcontent-qhb-c158=""
                                                        className="bb_head"
                                                      >
                                                        Amount
                                                      </p>
                                                      <div
                                                        _ngcontent-qhb-c158=""
                                                        className="input_dec select_dec2 marg-dec"
                                                      >
                                                        <input
                                                          _ngcontent-shi-c157=""
                                                          formcontrolname="amount"
                                                          type="number"
                                                          name="amount"
                                                          placeholder="Amount"
                                                          autoComplete="off"
                                                          className="amount number_only ng-untouched ng-pristine ng-invalid text-white w-100 p-2 rounded text-white"
                                                          min="100"

                                                          value={
                                                            upiTrans.amount
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-shi-c157=""
                                                      className="month_tab"
                                                    >
                                                         <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="0"
                                                        onClick={() =>
                                                          handleAmount("100")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +100{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="0"
                                                        onClick={() =>
                                                          handleAmount("300")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +300{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="1"
                                                        onClick={() =>
                                                          handleAmount("1000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +1000{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="2"
                                                        onClick={() =>
                                                          handleAmount("2000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +2000{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="3"
                                                        onClick={() =>
                                                          handleAmount("5000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +5000{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="4"
                                                        onClick={() =>
                                                          handleAmount("10000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +10000{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="5"
                                                        onClick={() =>
                                                          handleAmount("20000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +20000{" "}
                                                      </div>
                                                      <div
                                                        _ngcontent-shi-c157=""
                                                        className="quick_amt offline_amount label2 ng-star-inserted"
                                                        tabIndex="6"
                                                        onClick={() =>
                                                          handleAmount("25000")
                                                        }
                                                      >
                                                        <i _ngcontent-shi-c157=""></i>
                                                        +25000{" "}
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-qhb-c158=""
                                                      className="withdraw_text"
                                                    >
                                                      <p
                                                        _ngcontent-qhb-c158=""
                                                        className="bb_head"
                                                      >
                                                        Unique Transaction
                                                        Reference
                                                      </p>
                                                      <div
                                                        _ngcontent-qhb-c158=""
                                                        className="input_dec select_dec2 marg-dec"
                                                      >
                                                        <input
                                                          _ngcontent-shi-c157=""
                                                          formcontrolname="utrTransactionId"
                                                          type="text"
                                                          autoComplete="off"
                                                          id="reference_id"
                                                          name="utr"
                                                          className="amount number_only ng-untouched ng-pristine ng-invalid text-white w-100 p-2 rounded text-white"
                                                          placeholder="6 to 12 Digits UTR Number"
                                                          maxLength="12"
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </div>
                                                    </div>

                                                    <button
                                                      _ngcontent-shi-c157=""
                                                      className="bank-submit-btn text-dark cursor-pointer"
                                                      type="submit"
                                                      disabled={isSubmitting}
                                                      aria-busy={isSubmitting}
                                                    >
                                                      {isSubmitting ? "Submitting..." : "submit"}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {/* <Link
                                              _ngcontent-shi-c157=""
                                              target="_blank"
                                              className="payment-issue"
                                            >
                                              <h2
                                                _ngcontent-shi-c157=""
                                                className="info-eng"
                                              >
                                                For Payment Related issue click
                                                here
                                              </h2>
                                              <h2
                                                _ngcontent-shi-c157=""
                                                className="info-hnd"
                                              >
                                                {" "}
                                                भुगतान संबंधी समस्या के लिए यहां
                                                क्लिक करें{" "}
                                              </h2>
                                              <img
                                                _ngcontent-shi-c157=""
                                                className="whatsapp-icon"
                                                alt="whatsapp"
                                                src="/assets/images/whatsappImages.svg"
                                              />
                                            </Link>
                                            <div
                                              _ngcontent-shi-c157=""
                                              className="theme-card ng-star-inserted"
                                            >
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="payment-strip ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="title"
                                                >
                                                  Phonepay to Bank Transfer
                                                </span>
                                                <Link
                                                  _ngcontent-shi-c157=""
                                                  target="_blank"
                                                  className="pointer text-decoration-none"
                                                  href="https://kheloyartutorials.online/phonepe.html"
                                                >
                                                  https://kheloyartutorials.online/phonepe.html
                                                </Link>
                                              </div>
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="payment-strip ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="title"
                                                >
                                                  Paytm to Bank Transfer
                                                </span>
                                                <Link
                                                  _ngcontent-shi-c157=""
                                                  target="_blank"
                                                  className="pointer text-decoration-none"
                                                  href="https://kheloyartutorials.online/paytm.html"
                                                >
                                                  https://kheloyartutorials.online/paytm.html
                                                </Link>
                                              </div>
                                              <div
                                                _ngcontent-shi-c157=""
                                                className="payment-strip ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-shi-c157=""
                                                  className="title"
                                                >
                                                  Gpay to Bank Transfer
                                                </span>
                                                <Link
                                                  _ngcontent-shi-c157=""
                                                  target="_blank"
                                                  className="pointer text-decoration-none"
                                                  href="https://kheloyartutorials.online/google-pay.html"
                                                >
                                                  https://kheloyartutorials.online/google-pay.html
                                                </Link>
                                              </div>
                                            </div> */}
                                            {/* <div
                                              _ngcontent-shi-c157=""
                                              className="notesData"
                                            >
                                              <h3
                                                _ngcontent-shi-c157=""
                                                className="notes"
                                              >
                                                Note :
                                              </h3>
                                              <ul _ngcontent-shi-c157="">
                                                <li
                                                  _ngcontent-shi-c157=""
                                                  className="ng-star-inserted"
                                                >
                                                  {" "}
                                                  AFTER DEPOSIT, UPLOAD SLIP,
                                                  WRITE YOUR DEPOSIT AMOUNT{" "}
                                                </li>
                                                <li
                                                  _ngcontent-shi-c157=""
                                                  className="ng-star-inserted"
                                                >
                                                  {" "}
                                                  COPY THE SLIP &amp; ENTER THE
                                                  12 DIGIT UTR NUMBER.{" "}
                                                </li>
                                                <li
                                                  _ngcontent-shi-c157=""
                                                  className="ng-star-inserted"
                                                >
                                                  {" "}
                                                  CLICK SUBMIT BUTTON &amp;
                                                  RECIEVE POINTS &amp; BONUS
                                                  INSTANTLY.{" "}
                                                </li>
                                                <li
                                                  _ngcontent-shi-c157=""
                                                  className="ng-star-inserted"
                                                >
                                                  {" "}
                                                  NEFT RECIEVING TIME VARIES
                                                  FROM 40 MINUTES TO 1 HOUR.{" "}
                                                </li>
                                                <li
                                                  _ngcontent-shi-c157=""
                                                  className="ng-star-inserted"
                                                >
                                                  {" "}
                                                  SITE IS NOT RESPONSIBLE FOR
                                                  MONEY DEPOSITED TO OLD,
                                                  IN-ACTIVE OR CLOSED ACCOUNTS.{" "}
                                                </li>
                                              </ul>
                                            </div> */}
                                            {/* <div
                                              _ngcontent-shi-c157=""
                                              className="deposit-history"
                                            >
                                              <table
                                                _ngcontent-shi-c157=""
                                                className="table-borderless table-hover"
                                                style={{ width: "100%" }}
                                              >
                                                <thead _ngcontent-shi-c157="">
                                                  <tr _ngcontent-shi-c157="">
                                                    <th
                                                      _ngcontent-shi-c157=""
                                                      className="text-center"
                                                    >
                                                      Amount
                                                    </th>
                                                    <th
                                                      _ngcontent-shi-c157=""
                                                      className="text-center"
                                                    >
                                                      Status
                                                    </th>
                                                    <th
                                                      _ngcontent-shi-c157=""
                                                      className="text-center"
                                                    >
                                                      {" "}
                                                      Date &amp; Time{" "}
                                                    </th>
                                                    <th
                                                      _ngcontent-shi-c157=""
                                                      className="text-left"
                                                    >
                                                      File
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody
                                                  _ngcontent-shi-c157=""
                                                  className="xg-bet"
                                                >
                                                  <tr
                                                    _ngcontent-shi-c157=""
                                                    className="ng-star-inserted"
                                                  >
                                                    <td
                                                      _ngcontent-shi-c157=""
                                                      colSpan="12"
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    >
                                                      <p
                                                        _ngcontent-shi-c157=""
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {" "}
                                                        No Record Available
                                                      </p>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </app-manual-deposit>
                        )}
                        {/* USDT_deposit_method */}
                        {isUsdt && (
                          <UsdtDeposit onSubmitted={() => setRefresh((prev) => !prev)} />
                        )}
                      </auto-deposit>
                    </div>
                  </app-deposit>
                </div>
              </div>
              <div
                className="container-fluid px-3 pb-3"
                style={{ marginTop: "12px" }}
              >
                <div
                  className="d-flex justify-content-between align-items-center mb-2 px-3 py-2 rounded"
                  style={{ background: "var(--dark-theme-dark-blue-variant, #1d2333)" }}
                >
                  <h6
                    className="m-0"
                    style={{ color: "#fff", fontWeight: 600 }}
                  >
                    Recent Deposits
                  </h6>
                  <Link
                    to="/depositehistory"
                    style={{ fontSize: "0.85rem", color: "#9ad7ff" }}
                  >
                    View All
                  </Link>
                </div>
                <div className="search-table">
                  <div className="table-box no-more-tables">
                    <table
                      className="table-borderless"
                      style={{ width: "100%", background: "#fff", borderRadius: "6px" }}
                    >
                      <thead>
                        <tr style={{ background: "#f1f3f5" }}>
                          <th className="text-left" style={{ padding: "8px 12px", color: "#333" }}>
                            Amount
                          </th>
                          <th className="text-center" style={{ padding: "8px 12px", color: "#333" }}>
                            Bonus
                          </th>
                          <th className="text-center" style={{ padding: "8px 12px", color: "#333" }}>
                            Time
                          </th>
                          <th className="text-center" style={{ padding: "8px 12px", color: "#333" }}>
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {depositHistory === null ? (
                          <tr>
                            <td colSpan="4" className="text-center" style={{ padding: "12px", color: "#666" }}>
                              Loading...
                            </td>
                          </tr>
                        ) : depositHistory.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center" style={{ padding: "12px", color: "#666" }}>
                              No Record Available
                            </td>
                          </tr>
                        ) : (
                          depositHistory.slice(0, 5).map((d, i) => {
                            const bonus = Number(d.bonus_money) || 0;
                            return (
                              <tr key={i} className="xg-bet-tr" style={{ borderTop: "1px solid #eee" }}>
                                <td className="text-left" data-title="Amount" style={{ padding: "10px 12px", color: "#222" }}>
                                  {formatINR(d.money)}
                                </td>
                                <td className="text-center" data-title="Bonus" style={{ padding: "10px 12px", color: "#198754" }}>
                                  {d.status === 1 && bonus > 0 ? `+${formatINR(bonus)}` : "—"}
                                </td>
                                <td className="text-center" data-title="Time" style={{ padding: "10px 12px", color: "#444" }}>
                                  {d.today || d.requestTime}
                                </td>
                                <td className="text-center p-2" data-title="Status">
                                  <span className={d.status === 1 ? "approved-status" : d.status === 0 ? "" : "rejected-status"}>
                                    {d.status === 1 ? "Approved" : d.status === 0 ? "Pending" : "Rejected"}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div>
          </app-exchange>
        </div>
      </app-root>
    </>
  );
};
